import { getElement } from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

class FloatingButton {
  private readonly button: HTMLElement | null = null
  private scrollOffset: number = 360

  constructor() {
    this.button = getElement('floating-button')
  }

  public init(): void {
    if (this.button === null) return

    this.addEvents()
  }

  private addEvents(): void {
    window.addEventListener('scroll', (): void => this.toggle(), { passive: true })
  }

  private toggle(): void {
    if (window.scrollY > this.scrollOffset) {
      this.button?.classList.add(IS_ACTIVE)
    } else {
      this.button?.classList.remove(IS_ACTIVE)
    }
  }
}

const floatingButton = new FloatingButton()
floatingButton.init()
